<h3>Homologar Férias</h3>
<a href="#" class="sr-only">Homologar Férias</a>
<app-cabecalho-funcional [exercicioSelecionado]="exercicioSelecionado" [exibirPeriodoProgramacaoDisponivel]="false" [exibirTipoPeriodoAquisitivo]="false"></app-cabecalho-funcional>
<div class="row">
    <div class="col-sm-12">
        <ng-container *ngFor="let parcela of parcelasFerias; let i = index">
            <h4 style="color: var(--active)">{{ parcela.ordem + (parcela.geracao > 0 ? "." + parcela.geracao : "") }}ª Parcela</h4>
            <div class="br-card">
                <div class="row" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-2 mt-2">
                        <label [for]="'campo-data-inicio_' + i">Período de Férias</label>
                        <br />
                        <p class="mb-0">
                            {{ parcela.dataInicio | dataFormatada }} a
                            {{ parcela.dataFim | dataFormatada }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2">
                        <label [for]="'campo-quantidade-dias_' + i">Quantidade de dias</label>
                        <p class="mb-0">{{ parcela.quantidadeDias }}</p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2 desktop-only">
                        <label>Situação</label>
                        <br />
                        <p-tag [value]="parcela.situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + parcela.situacao.codigoCor + ' 100%,' + parcela.situacao.codigoCor + ' 100%)' }"></p-tag>
                    </div>
                </div>
                <div class="row" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-2 mt-2">
                        <p class="label mb-1">Adicionais de Férias</p>
                        <p class="mb-0" *ngIf="parcela.adiantamentoDecimoTerceiro.valor">Adiantamento 13º</p>
                        <p class="mb-0" *ngIf="parcela.adiantamentoSalarial.valor">Adiantamento Salarial</p>
                        <p class="mb-0" *ngIf="parcela.abonoPecuniario.valor">Abono Pecuniário</p>
                        <p class="mb-0" *ngIf="!parcela.adiantamentoDecimoTerceiro.valor && !parcela.adiantamentoSalarial.valor && !parcela.abonoPecuniario.valor">Não solicitado</p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2 br-input" *ngIf="parcela.adiantamentoSalarial.valor">
                        <p class="label mb-1">Parcelas de Desconto</p>
                        <p class="mb-0">{{ parcela.parcelasDesconto }}</p>
                    </div>
                </div>
                <div class="row mobile-only" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-12 mt-2">
                        <label>Situação</label>
                        <br />
                        <p-tag [value]="parcela.situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + parcela.situacao.codigoCor + ' 100%,' + parcela.situacao.codigoCor + ' 100%)' }"></p-tag>
                    </div>
                </div>
                <div class="row" style="padding-bottom: 10px">
                    <!--padding-bottom-->
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div class="row">
    <div class="col-12 mt-2">
        <label for="aviso">Aviso</label>
        <p id="aviso">A homologação ou recusa da programação/reprogramação de férias deve ser feita pela chefia imediata no SouGov. A Gestão de Pessoas atua apenas em casos excepcionais e justificados.</p>
    </div>
</div>
<div class="br-textarea" [ngClass]="{ danger: justificativaParaHomologarFeriasInvalida }">
    <label for="textarea-id8">Justificativa de homologação pela gestão de pessoas (Obrigatório)</label>
    <textarea id="textarea-id8" class="mt-1" rows="6" cols="90" pInputTextarea autoResize="autoResize" style="width: 100%" [(ngModel)]="justificativaParaHomologarFerias" maxlength="300" (input)="onJustificativaParaHomologarFeriasChange($event)" (blur)="validarJustificativaParaHomologarFerias()"></textarea>
    <div class="text-base mt-1">
        <span class="limit" aria-live="polite">
            <b>{{ justificativaParaHomologarFerias.length }}</b>
            de
            <b>300</b>
            caracteres digitados
        </span>
        <span class="current" aria-live="polite" role="status" id="limitmax"></span>
    </div>
    <p class="mt-1" *ngIf="justificativaParaHomologarFeriasInvalida">
        <span class="feedback danger" role="alert">
            <i class="fas fa-times-circle" aria-hidden="true"></i>
            {{ msgJustificativaObrigatoria }}
        </span>
    </p>
</div>
<div class="row mt-2">
    <div class="col text-right">
        <button aria-label="botão voltar" id="botao-voltar" pButton type="button" label="Voltar" class="mr-2 botao-responsivo" (click)="confirmarVoltar()"></button>
        <button aria-label="botão recusar" id="botao-recusar" pButton type="button" label="Recusar" class="secondary mr-2 botao-responsivo" (click)="confirmarRecusa()"></button>
        <button aria-label="botão recusar" id="botao-recusar" pButton type="button" label="Homologar" class="primary botao-responsivo" (click)="confirmarHomologacao()"></button>
    </div>
</div>
<p-confirmDialog key="confirmPadrao" acceptLabel="Sim" rejectLabel="Não"></p-confirmDialog>
<p-confirmDialog key="confirmAcumuloFerias" acceptLabel="Sim" rejectLabel="Não">
    <ng-template pTemplate="message">
        <table class="confirm-dialog">
            <tr>
                <td>
                    <p id="aviso" *ngIf="!homologacaoComAcumuloFeriasNoTerceiroPeriodo">
                        <b>Aviso Importante:</b>
                        O servidor pode acumular até dois períodos de férias se houver necessidade do serviço ou em caso de licença à gestante, à adotante, licença-paternidade e licenças para tratar da própria saúde. Assim, é necessário justificar o acúmulo de férias.
                    </p>
                    <p id="aviso" *ngIf="homologacaoComAcumuloFeriasNoTerceiroPeriodo">
                        <b>Declaro, estar ciente de que a acumulação de férias por três períodos somente é permitida em situações excepcionais e por necessidade do serviço, cabendo à chefia a devida justificativa e responsabilidade por essa decisão.</b>
                    </p>
                </td>
            </tr>
            <tr>
                <td>
                    <label>
                        Justificativa para Acúmulo de Férias
                        {{ homologacaoComAcumuloFeriasNoTerceiroPeriodo ? " - Terceiro Período" : "" }}
                        (Obrigatório)
                    </label>
                    <br />
                    <textarea class="mt-1" rows="6" cols="90" pInputTextarea autoResize="autoResize" style="width: 100%" [(ngModel)]="justificativaParaAcumuloFerias" maxlength="300" (input)="onJustificativaParaAcumuloFeriasChange($event)" (blur)="validarJustificativaParaAcumuloFerias()"></textarea>
                    <b>{{ justificativaParaAcumuloFerias.length }}</b>
                    de
                    <b>300</b>
                    caracteres digitados
                    <p class="mt-1" *ngIf="justificativaParaAcumuloFeriasInvalida">
                        <span class="feedback danger" role="alert">
                            <i class="fas fa-times-circle" aria-hidden="true"></i>
                            {{ msgJustificativaAcumuloFeriasObrigatoria }}
                        </span>
                    </p>
                </td>
            </tr>
            <tr>
                <td style="padding-bottom: 0px !important">
                    <span>Tem certeza que deseja homologar as férias do exercício de {{ exercicioSelecionado.anoExercicio }}?</span>
                </td>
            </tr>
        </table>
    </ng-template>
</p-confirmDialog>
<p-confirmDialog key="confirmRecusar" acceptLabel="Sim" rejectLabel="Não">
    <ng-template pTemplate="message">
        <table class="confirm-dialog">
            <tr>
                <td>
                    <p id="aviso">Você precisa justificar a recusa da solicitação de Férias:</p>
                </td>
            </tr>
            <tr>
                <td>
                    <label>Justificativa para recusa de Férias (Obrigatório)</label>
                    <br />
                    <textarea class="mt-1" rows="6" cols="90" pInputTextarea autoResize="autoResize" style="width: 100%" [(ngModel)]="justificativaParaRecusaFerias" maxlength="300" (input)="onJustificativaParaRecusaFeriasChange($event)" (blur)="validarJustificativaParaRecusaFerias()"></textarea>
                    <b>{{ justificativaParaRecusaFerias.length }}</b>
                    de
                    <b>300</b>
                    caracteres digitados
                    <p class="mt-1" *ngIf="justificativaParaRecusaFeriasInvalida">
                        <span class="feedback danger" role="alert">
                            <i class="fas fa-times-circle" aria-hidden="true"></i>
                            {{ msgJustificativaRecusaFeriasObrigatoria }}
                        </span>
                    </p>
                </td>
            </tr>
            <tr>
                <td style="padding-bottom: 0px !important">
                    <span>Tem certeza que deseja recusar a solicitação de férias do exercício de {{ exercicioSelecionado.anoExercicio }}?</span>
                </td>
            </tr>
        </table>
    </ng-template>
</p-confirmDialog>
